<!-- src/app/pages/prescription/prescription-list/prescription-by-id-patient/prescription-by-id-patient.component.html -->
<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card">

      <!-- ========================================================= -->
      <!-- ✅ FILTROS + SELECT TUTOR + BOTON BUSCAR (MISMA LINEA) -->
      <!-- ========================================================= -->
      <div class="content-block" *ngIf="!embeddedInProfile">
        <div class="row m-2 align-items-start">

          <!-- FECHA INICIAL -->
          <div class="col-lg-2 col-md-4 col-sm-12 col-xs-12">
            <mat-form-field appearance="outline" class="date-field example-full-width">
              <mat-label>FECHA INICIAL</mat-label>
              <input
                (dateChange)="onDateChange()"
                [(ngModel)]="filterReceta.startDate"
                [matDatepicker]="fechaInicial"
                aria-autocomplete="none"
                autocomplete="nope"
                matInput
              />
              <button
                (click)="clearDate('startDate')"
                *ngIf="filterReceta.startDate"
                aria-label="Clear Fecha Inicial"
                mat-icon-button
                matSuffix
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle [for]="fechaInicial" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #fechaInicial></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- FECHA FINAL -->
          <div class="col-lg-2 col-md-4 col-sm-12 col-xs-12">
            <mat-form-field appearance="outline" class="date-field example-full-width">
              <mat-label>FECHA FINAL</mat-label>
              <input
                (dateChange)="onDateChange()"
                [(ngModel)]="filterReceta.endDate"
                [matDatepicker]="fechaFinal"
                aria-autocomplete="none"
                autocomplete="nope"
                matInput
              />
              <button
                (click)="clearDate('endDate')"
                *ngIf="filterReceta.endDate"
                aria-label="Clear Fecha Final"
                mat-icon-button
                matSuffix
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle [for]="fechaFinal" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #fechaFinal></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- ✅ SELECT TUTOR (solo si aplica) -->
          <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12" *ngIf="showTutorSelect">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>SELECCIONA PACIENTE</mat-label>

              <mat-select
                [(ngModel)]="selectedPacienteId"
                (selectionChange)="onTutorPacienteChange()">

                <!-- ✅ placeholder real (seleccionable) -->
                <mat-option [value]="null">SELECCIONA PACIENTE</mat-option>

                @for (p of tutorPacientes; track p.idPaciente) {
                  <mat-option [value]="p.idPaciente">
                    <div class="tutor-option">
                      <div class="avatar">
                        @if (p.imagenSrc) {
                          <img [src]="p.imagenSrc" alt="IMG" />
                        } @else {
                          <span class="initials">{{ p.initials }}</span>
                        }
                      </div>

                      <div class="info">
                        <div class="name">{{ p.nombreCompleto }}</div>
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- ✅ BOTON BUSCAR (MISMA LINEA) -->
          <div class="col-lg-2 col-md-6 col-sm-12 col-xs-12 d-flex justify-content-end">
            <button (click)="buscar()" class="mt-1 btn-buscar" color="primary" mat-raised-button>
              BUSCAR
            </button>
          </div>

          <div *ngIf="showHipFeatures" class="col-lg-2 col-md-6 col-sm-12 col-xs-12 d-flex justify-content-end">
            <button
              (click)="descargarHip()"
              [disabled]="hipLoading"
              class="mt-1 btn-hip"
              color="primary"
              mat-raised-button
              matTooltip="Descargar HIP">
              <mat-icon *ngIf="!hipLoading">description</mat-icon>
              <mat-progress-spinner
                *ngIf="hipLoading"
                color="primary"
                [diameter]="18"
                mode="indeterminate">
              </mat-progress-spinner>
              <span>HIP</span>
            </button>
          </div>
        </div>
      </div>

      <!-- ========================================================= -->
      <!-- ✅ CARD "RECETAS DE" (DESPUES DE FILTROS, ANTES DE LA TABLA) -->
      <!-- ========================================================= -->
      @if (selectedPacienteVm) {
        <div class="selected-card-wrap">
          <div class="selected-card">
            <button
              type="button"
              class="selected-close"
              mat-icon-button
              (click)="clearSelectedPaciente()"
              aria-label="Cerrar">
              <mat-icon>close</mat-icon>
            </button>

            <div class="selected-left">
              <div class="avatar lg">
                @if (selectedPacienteVm.imagenSrc) {
                  <img [src]="selectedPacienteVm.imagenSrc" alt="IMG" />
                } @else {
                  <span class="initials">{{ selectedPacienteVm.initials }}</span>
                }
              </div>
            </div>

            <div class="selected-right">
              <div class="label">RECETAS DE:</div>
              <div class="title">{{ selectedPacienteVm.nombreCompleto }}</div>
            </div>
          </div>
        </div>
      }

      <!-- ✅ HINT CUANDO ES PERFIL -->
      <div *ngIf="embeddedInProfile" class="mes-actual-wrap">
        <div class="mes-actual-chip">
          <mat-icon>event</mat-icon>
          <span>MOSTRANDO: {{ currentMonthLabel }}</span>
        </div>
        <button
          *ngIf="showHipFeatures"
          (click)="descargarHip()"
          [disabled]="hipLoading"
          class="btn-hip btn-hip-profile"
          color="primary"
          mat-raised-button
          matTooltip="Descargar HIP">
          <mat-icon *ngIf="!hipLoading">description</mat-icon>
          <mat-progress-spinner
            *ngIf="hipLoading"
            color="primary"
            [diameter]="18"
            mode="indeterminate">
          </mat-progress-spinner>
          <span>HIP</span>
        </button>
      </div>
      <!-- ========================================================= -->
      <!-- HEADER TABLA -->
      <!-- ========================================================= -->
      <div class="materialTableHeader">
        <div class="left">
          <ul class="header-buttons-left ms-0">
            <li class="tbl-search-box">
              <label><i class="material-icons search-icon">search</i></label>
              <input
                #filter
                aria-autocomplete="none"
                aria-label="Search box"
                autocomplete="nope"
                class="browser-default search-field"
                placeholder="BUSCAR"
                type="text" data-tour="pat-rx-search">
            </li>
          </ul>
        </div>
        <div class="right">
          <ul class="tbl-export-btn">
            <li class="tbl-header-btn">
              <div class="m-l-10" matTooltip="RECARGAR">
                <button (click)="refresh()" color="primary" mat-mini-fab data-tour="pat-rx-refresh">
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </li>
            @if (!isPatient) {
              <li>
                <div class="export-button m-l-10" matTooltip="EXCEL">
                  <img (click)="exportExcel()" alt="" height="512" ngSrc="assets/images/icons/xlsx.png" width="512"/>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>

      <div class="body overflow-auto">
        <div class="responsive_table">

          <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

            <ng-container matColumnDef="folio">
              <mat-header-cell *matHeaderCellDef mat-sort-header>FOLIO DE LA RECETA</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.folio}}">
                <span class="mobile-label">FOLIO:</span>
                <div class="block">
                  <span class="prop_four">{{ row.folio ? row.folio : 'SIN FOLIO' }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="medico">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> MEDICO</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.nombreMedico}}">
                <span class="mobile-label">Medico: </span>
                <div class="block">
                  <span class="prop_three">{{ row.nombreMedico }}</span>
                  <span class="prop_two">CED. {{ row.cedulaGeneral }}</span>
                  <span class="prop_two">ESPECIALIDAD: {{ row.especialidad ? row.especialidad : 'Sin especialidad' }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="gemp">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> GRUPO Y SUCURSAL</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.grupoEmpresarial}}">
                <span class="mobile-label">Grupo y Sucursal: </span>
                <div class="block">
                  <span class="prop_one">{{ row.grupoEmpresarial }}</span>
                  <span class="prop_two">{{ row.sucursal }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="creacion">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> FECHA DE CREACION</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.fechaCreacion}}">
                <span class="mobile-label">Fecha de Creacion: </span>
                <div class="block">
                  <span class="prop_two">{{ row.fechaCreacion }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="pr-0"> ESTATUS</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                <span class="mobile-label">STATUS:</span>
                @if (row.estatusReceta === 'Activa') { <span class="badge badge-solid-orange">{{ row.estatusReceta }}</span> }
                @if (row.estatusReceta === 'Surtida') { <span class="badge badge-solid-green">{{ row.estatusReceta }}</span> }
                @if (row.estatusReceta === 'Cancelada') { <span class="badge badge-solid-red">{{ row.estatusReceta }}</span> }
                @if (row.estatusReceta === 'Vencida') { <span class="badge badge-solid-brown">{{ row.estatusReceta }}</span> }
                @if (row.estatusReceta === 'Surtida Parcialmente') { <span class="badge badge-solid-blue">{{ row.estatusReceta }}</span> }
                @if (row.estatusReceta === 'Vencida Surtida Parcialmente') { <span class="badge badge-solid-purple">{{ row.estatusReceta }}</span> }
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="detalles">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>
                {{ control ? 'MEDICAMENTOS' : 'DETALLES' }}
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                <span class="mobile-label">{{ control ? 'MEDICAMENTOS:' : 'DETALLES:' }}:</span>
                <button
                  (click)="$event.stopPropagation(); goToDetails(row)"
                  class="tbl-fav-std"
                  mat-icon-button
                  [matTooltip]="control ? 'VER MEDICAMENTOS' : 'VER DETALLES'"
                  matTooltipPosition="above">

                  <mat-icon>{{ control ? 'medication' : 'visibility' }}</mat-icon>
                </button>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="descargar">
              <mat-header-cell *matHeaderCellDef class="pr-0"> DESCARGAR RECETA</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                <span class="mobile-label">Descargar Receta:</span>
                <button
                  (click)="$event.stopPropagation(); descargarPDF(row)"
                  class="tbl-fav-std"
                  mat-icon-button
                  *ngIf="row.generarPDF">
                  <app-feather-icons [icon]="'download'"></app-feather-icons>
                </button>
                <button
                  (click)="$event.stopPropagation(); enviarRecetaPorCorreo(row)"
                  class="tbl-fav-std"
                  mat-icon-button
                  matTooltip="Enviar receta por correo"
                  *ngIf="row.generarPDF">
                  <mat-icon color="primary">mail</mat-icon>
                </button>
                <span *ngIf="!row.generarPDF" class="text-muted no-disponible">
                  <mat-icon aria-label="No disponible" class="icono">block</mat-icon>
                  <span>NO DISPONIBLE</span>
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="mostrarQr">
              <mat-header-cell *matHeaderCellDef class="pr-0"> CODIGO QR</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                <span class="mobile-label">QR DE LA RECETA:</span>
                @if (isPatient) {
                  <button
                    (click)="$event.stopPropagation(); showQr(row)"
                    class="tbl-fav-std"
                    mat-icon-button
                    matTooltip="Mostrar QR"
                    *ngIf="row.generarQR">
                    <img ngSrc="assets/images/icons/qr.svg" width="24" height="24" alt="QR">
                  </button>
                }
                <span *ngIf="!row.generarQR" class="text-muted no-disponible">
                  <mat-icon aria-label="No disponible" class="icono">block</mat-icon>
                  <span>NO DISPONIBLE</span>
                </span>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
          </table>

          @if (data?.isTblLoading) {
            <div class="tbl-spinner">
              <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate"></mat-progress-spinner>
            </div>
          }

          @if (!data?.isTblLoading) {
            <div class="no-results" [style.display]="(dataSource.renderedData.length || 0) === 0 ? '' : 'none'">
              SIN RESULTADOS
            </div>
          }

          <mat-paginator
            [length]="dataSource.filteredData.length || 0"
            [pageIndex]="0"
            [pageSizeOptions]="[5, 10, 25, 100]"
            [pageSize]="10">
          </mat-paginator>

        </div>
      </div>
    </div>
  </div>
</div>
